import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

export default function FieldMapperSourceDropdown(props: {
  disabled?: boolean;
  onSelect: (value: string) => void;
  selectedTaskSchema: {id: string; name: string} | null;
  possibleTaskSchemas: Array<{id: string; name: string}>;
  dataTestAttrs?: DataTestAttrs;
}): JSX.Element {
  return (
    <SelectDropdown
      dataTestAttrs={props.dataTestAttrs}
      disabled={props.disabled}
      displayName={props.selectedTaskSchema?.name ?? 'Select a source'}
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
          {props.possibleTaskSchemas.map(({id, name}) => (
            <Option
              key={id}
              value={id}
              onSelect={(value: string) => {
                props.onSelect(value);
              }}
            >
              {name}
            </Option>
          ))}
        </Menu>
      }
    />
  );
}
